import { useQuery } from '@tanstack/react-query';
import { useAPI } from './useAPIs';
import { hasValue } from '../utils/CommonUtils';

export const useEventTypes = (debouncedFilters, createIsoStringWithTimezone, dateType) => {
  const { apiCall } = useAPI();

  const buildParams = (filters, dateType) => {
    const params = new URLSearchParams();
    if (filters.start_datetime) params.append('start_datetime', createIsoStringWithTimezone(filters.start_datetime));
    if (filters.end_datetime) params.append('end_datetime', createIsoStringWithTimezone(filters.end_datetime));
    params.append('use_datetime_type', dateType);
    if (hasValue(filters.vin)) params.append('vin', filters.vin.join(","));
    if (hasValue(filters.mac_id)) params.append('mac_id', filters.mac_id.join(","));
    return params;
  };

  const hasVinOrMacId = hasValue(debouncedFilters?.vin) || hasValue(debouncedFilters?.mac_id);

  const eventTypesQuery = useQuery({
    queryKey: ['eventTypes', debouncedFilters, dateType],
    queryFn: async () => {
      const params = buildParams(debouncedFilters, dateType);
      const response = await apiCall('GET', 'events/summaries', { params });
      return response.data;
    },
    enabled: hasVinOrMacId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    select: (data) => data.grouped_summaries || [],
  });

  return {
    eventTypesQuery,
    hasVinOrMacId,
    eventTypes: eventTypesQuery.data || [],
  };
};